export default __webpack_public_path__ + "static/media/mamounsfalafel.e931479c.jpeg";